export default {
  investor: {},
  detailView: {
    loading: true,
  },
};
